(function($) {
	
	'use strict'
	
	var init = function() {
		initSwiper()
	}

	var initSwiper = function() {
		var swiper = new Swiper('.swiper-container', {
            slidesPerView: 1,
			spaceBetween: 0,
			breakpoints: {
				768: {
					slidesPerView: 2,
                },
                992: {
					slidesPerView: 4,
					resistanceRatio: 0,
                },
            }
        })
	}

	$(document).ready(function() {
		init()
	})

})(jQuery)
